import {MvsObjectNavigationProviderInterface} from "../mvs-object-navigation-provider.interface";
import {MvsObjectNavigationEntry} from "../mvs-object-navigation-entry";
import {MvsObjectNavigationNode} from "../mvs-object-navigation-node";
import {MvsObjectNavigationActionEnum} from "../mvs-object-navigation-action-enum";
import {MvsObjectNavigationIdentifier} from "../mvs-object-navigation-identifier";
import {ObjectIdentifier} from "../../basic/object-identifier";
import {ObjectBrowserResultEntryDto} from "../../object/dto/object-browser-result-entry.dto";
import {ObjectBrowserResultDto} from "../../object/dto/object-browser-result.dto";

export class MvsObjectNavigationProviderOb implements MvsObjectNavigationProviderInterface {

    constructor(protected objectBrowser: ObjectBrowserResultDto) {
    }



    /**
     * Get navigation entries.
     */
    getNavigationsEntries(): MvsObjectNavigationEntry[] {

        const collectedEntries: MvsObjectNavigationEntry[] = [];

        this.collectNavigationsEntries(this.objectBrowser.root, collectedEntries)

        return collectedEntries;
    }

    /**
     * collect all entries.
     * @param entry
     * @param entries
     */
    protected collectNavigationsEntries(entry: ObjectBrowserResultEntryDto, entries: MvsObjectNavigationEntry[]) {

        if (!entry.dummy) {

            // add this entry
            entries.push(this.convertResultEntryToNavigationEntry(entry));
        }


        if (entry.children) {
            for (let child of entry.children) {
                this.collectNavigationsEntries(child, entries);
            }
        }

    }

    getNavigationEntriesFromObject(objectIdentifier: MvsObjectNavigationIdentifier, levels: number) : MvsObjectNavigationNode {

        const node: MvsObjectNavigationNode = new MvsObjectNavigationNode();

        this.collectNavigationEntriesFromObject(
            objectIdentifier,
            0,
            -1,
            levels,
            this.objectBrowser.root,
            null,
            node);

        return node;

    }

    protected collectNavigationEntriesFromObject(
        selectedObject: ObjectIdentifier,
        actualLevel: number,
        currentLevel: number,
        maxLevel: number,
        entry: ObjectBrowserResultEntryDto,
        parentNavigationEntry: MvsObjectNavigationEntry,
        node: MvsObjectNavigationNode) {

        let myLevel = currentLevel;
        let myNavigationEntry: MvsObjectNavigationEntry = null;

        // check whether the maximum level was already retrieved
        if (currentLevel > maxLevel) {
            return;
        }

        // the root entry was not found yet
        if (currentLevel == -1) {

            if (!selectedObject || ObjectIdentifier.compareFields(selectedObject, entry.objectAlias, entry.objectId) ) {

                myLevel = 0; // this is the root object
                myNavigationEntry = this.convertResultEntryToNavigationEntry(entry);
                node.nodeElement = myNavigationEntry;
                node.nodeLevel = actualLevel;

            }
        } else if (currentLevel > 0) {

            myNavigationEntry = this.convertResultEntryToNavigationEntry(entry);

            if (currentLevel == 1) {
                node.entries.push(myNavigationEntry);
            } else {
                parentNavigationEntry.addChild(myNavigationEntry);
            }

        }


        if (entry.children) {

            for (let child of entry.children) {

                const nextLevel: number = (myLevel >= 0 ? myLevel + 1 : -1);

                this.collectNavigationEntriesFromObject(
                    selectedObject,
                    actualLevel + 1,
                    nextLevel,
                    maxLevel,
                    child,
                    myNavigationEntry,
                    node
                );
            }
        }

    }


    getNavigationPath(objectIdentifier: MvsObjectNavigationIdentifier) : MvsObjectNavigationEntry[] {
        const levels : ObjectBrowserResultEntryDto[] = [];
        return this.collectNavigationPath(objectIdentifier, 0, this.objectBrowser.root, levels);
    }



    protected collectNavigationPath(
        selectedObject: ObjectIdentifier,
        currentLevel: number,
        entry: ObjectBrowserResultEntryDto,
        levels: ObjectBrowserResultEntryDto[]) : MvsObjectNavigationEntry[] {

        if (!selectedObject) {
            return [];
        }

        if (!entry.createEntry) {
            if (ObjectIdentifier.compareFields(selectedObject, entry.objectAlias, entry.objectId)) {
                const path: MvsObjectNavigationEntry[] = [];
                for (let i = 0; i < currentLevel; i++) {
                    path.push(this.convertResultEntryToNavigationEntry(levels[i]));
                }
                return path;
            }
        }

        if (entry.children) {
            for (let child of entry.children) {
                levels[currentLevel] = child;
                const mvsObjectNavigationEntries = this.collectNavigationPath(selectedObject, currentLevel + 1, child, levels);

                if (mvsObjectNavigationEntries !== null) {
                    return mvsObjectNavigationEntries;
                }
            }
        }

        return null;

    }

    /**
     * Derive navigation type based on result entry.
     * @param entry
     */
    public static getNavigationType(entry: ObjectBrowserResultEntryDto) {

        if (entry.createEntry) {
            return "create";
        } else if (entry.dummy) {
            return "dummy";
        } else {
            return "object";
        }

    }

    protected convertResultEntryToNavigationEntry(entry: ObjectBrowserResultEntryDto) : MvsObjectNavigationEntry{

        let action = MvsObjectNavigationActionEnum.any;

        if (entry.createEntry) {
            action = MvsObjectNavigationActionEnum.create;
        }

        return MvsObjectNavigationEntry.createNavigationEntry(
            entry.objectAlias,
            entry.objectId,
            MvsObjectNavigationProviderOb.getNavigationType(entry),
            entry.objectName,
            entry.image,
            entry.description,
            action
        );

    }


}
